<script>
  export let item;
  export let moderator;
  export let jumptoEventsPageTermin;

  let targetName = "";

  const split = item.startTime.split(":");
  const hours = parseInt(split[0]);
  const minutes = parseInt(split[1] || 0);
  const offsetMinutes = (hours - 8) * 60 + minutes;

  let timeblockStyle = "position: absolute; top: " + offsetMinutes * 3 + "px; height: " + 50 * 3 + "px; cursor: pointer;";

  async function startJumptoEventsDetails() {
    if (item.terminId > 0) {
      targetName = "termin_" + item.terminId;
    } else {
      if (item.veranstaltungId > 0) {
        targetName = "v_" + item.veranstaltungId;
      }
    }
    jumptoEventsPageTermin(targetName);
  }
</script>

<div class="left-[2%] w-[46%] border border-solid border-gray-400/50 bg-im-signal p-4 text-white drop-shadow-md lg:p-1" style={timeblockStyle}>
  <button class="h-max w-max" on:click={startJumptoEventsDetails}>
    <p class="flex items-center gap-1 text-xs font-bold">
      <svg class="svg-inline--fa fa-sm" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
        ><path
          d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        ></path></svg
      ><span
        >{item.startTime}{#if item.endTime}-{item.endTime}{/if} Uhr</span
      >
    </p>
    <p class="not-prose flex px-2 py-0.5 text-xs uppercase tracking-widest">
      {#if item.typ == 1}
        <img src="/content/im/templates/img/Kongresstool/ico_ws_white.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Workshop" title="Workshop" /><span class="mx-2 my-4"
          ><strong class="text-white">WS</strong></span
        >
      {:else if item.typ == 2}
        <img src="/content/im/templates/img/Kongresstool/ico_ws_white.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><span class="mx-2 my-4"
          ><strong class="text-white">GG</strong></span
        >
      {:else if item.typ == 3}
        <img src="/content/im/templates/img/Kongresstool/ico_ws_white.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="One to One" title="One to One" /><span class="mx-2 my-4"
          ><strong class="text-white">o2o</strong></span
        >
      {:else if item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11 || item.typ == 12}
        <strong>IM Spezial</strong>
      {/if}
    </p>
    {#if item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11 || item.typ == 12}
      <p class="not-prose flex w-[46%] px-2 py-0.5 text-xs uppercase tracking-widest">
        {item.referent1name}
      </p>
    {/if}
    {#if moderator}<p class="not-prose flex justify-center">Moderator</p>{/if}
  </button>
</div>
